import * as FIELD_NAME from 'constant/form-item-names'
import * as NUMBER from 'constant/number'
import * as RULES from 'constant/form-rules'
import * as FIELD_LABEL from 'constant/form-labels'
import { TreeSelect, Form } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'

const { SHOW_CHILD } = TreeSelect

const OrganisationSelect = ({ organisations, hidden = false, disabled = false }) => {
  return (
    <>
      <span>{FIELD_LABEL.ORGANISATION_SELECT}</span>
      <Form.Item
        hidden={hidden}
        name={FIELD_NAME.ORGANISATION_UUIDS}
        rules={[RULES.REQUIRED]}
      >
        <TreeSelect
          allowClear
          bordered={false}
          disabled={disabled}
          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
          getPopupContainer={trigger => trigger.parentNode}
          maxTagCount={NUMBER.TEN}
          multiple
          placeholder={'View Permissions'}
          showCheckedStrategy={SHOW_CHILD}
          showSearch={false}
          size='large'
          style={{ background: '#fff' }}
          treeCheckable
          treeData={organisations}
        />
      </Form.Item>
    </>
  )
}

OrganisationSelect.propTypes = {
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  organisations: PropTypes.array
}

export default OrganisationSelect
